import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import Flickity from "flickity";
import {
  flickityReadyHandler,
  flickityChangeHandler,
  flickitySettleHandler,
} from "../utils/flickity";

export default class Timeline {
  constructor(elem, APP) {
    this.elem = elem;
    this.circle = this.elem.querySelector(".js-circle");
    this.dots = this.elem.querySelectorAll(".js-dot");
    this.dotYears = this.elem.querySelectorAll(".js-dot-year");
    this.carousel = this.elem.querySelector(".js-slider");
    this.angles = [];

    // filters
    this.trigger = this.elem.querySelector(".js-filter-trigger");
    this.listContainer = this.elem.querySelector(".js-filter-panel");
    this.radios = this.elem.querySelectorAll(".js-filter-ul input");

    // panels
    this.panels = this.elem.querySelectorAll(".js-panel");
    this.bgs = this.elem.querySelectorAll(".js-bg");

    this.currentIndex = 0;

    gsap.registerPlugin(Draggable);
  }

  setupCarousel() {
    this.flkty = new Flickity(this.carousel, {
      // setGallerySize: false,
      accessibility: false,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false,
      imagesLoaded: true,
      cellAlign: "left",
      contain: true,
      groupCells: true,
      on: {
        // ready: () => {
        //   this.dots = this.elem.querySelectorAll(".flickity-page-dots button");
        //   flickityReadyHandler(this.carousel, this.dots);
        // },
        change: (index) => {
          // flickityChangeHandler(this.dots, index);
          this.currentIndex = index;
          this.updateIndex();
        },
        settle: () => {
          flickitySettleHandler(this.carousel.querySelectorAll(".js-slide"));
        },
      },
    });
  }

  setupFilters() {
    /* toggle expanded */
    this.trigger.addEventListener("click", () => {
      const isExpanded = this.trigger.getAttribute("aria-expanded");

      this.trigger.setAttribute(
        "aria-expanded",
        isExpanded === "true" ? false : true
      );
    });

    this.radios.forEach((rdo, i) => {
      rdo.addEventListener("click", () => {
        this.trigger.setAttribute("aria-expanded", false);
        this.currentIndex = i;
        this.updateIndex();
      });
    });

    // ada
  }

  updateIndex(rotateCircle = true) {
    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        this.panels[index].classList.add("active");
        this.bgs[index].classList.add("active");
        this.trigger.innerHTML = this.radios[index].value;
        gsap.to(this.dotYears[index], { color: '#2DEDEA' });
        // dot.classList.add("active");
      } else {
        this.panels[index].classList.remove("active");
        this.bgs[index].classList.remove("active");
        gsap.to(this.dotYears[index], { color: '#ffffff' });
        // dot.classList.remove("active");
      }
    });

    // radio
    this.radios[this.currentIndex].checked = true;

    // carousel
    if (this.flkty) this.flkty.select(this.currentIndex);

    // circle
    if (rotateCircle) {
      let targetAngle = 360 - this.angles[this.currentIndex] + 180;
      gsap.to(this.circle, {
        rotation: targetAngle,
        duration: 0.3,
        ease: "power2.out",
      });
    }
  }

  rotateCircle() {
    const total = this.dots.length;
    const angle = 360 / total;

    this.dots.forEach((dot, i) => {
      const targetDeg = 360 - (i + 1) * angle;
      dot.style.transform = `rotate(${targetDeg}deg)`;
      this.angles.push(targetDeg);
    });
    console.log("angles", this.angles);

    let prevRotation = 0;
    let targetAngle = 360 - this.angles[0] + 180;
    gsap.to(this.circle, { rotation: targetAngle, duration: 0.3 });
    console.log("target angle", targetAngle);

    const thisClass = this;

    const draggable = Draggable.create(this.circle, {
      type: "rotation",
      onDragStart: function () {
        prevRotation = this.rotation;
      },
      onDragEnd: function () {
        console.log(
          "this.rotation",
          this.rotation,
          "prevRotation",
          prevRotation
        );
        if (prevRotation > this.rotation) {
          //up - degree
          thisClass.currentIndex--;
          if (thisClass.currentIndex < 0) thisClass.currentIndex = total - 1;
          targetAngle = targetAngle - angle;
          console.log("-", targetAngle, "currentIndex", thisClass.currentIndex);
          gsap.to(this.target, {
            rotation: targetAngle,
            ease: "power2.out",
            duration: 0.4,
          });
        } else {
          // down + degree
          thisClass.currentIndex++;
          if (thisClass.currentIndex >= total) thisClass.currentIndex = 0;
          targetAngle = targetAngle + angle;
          console.log("+", targetAngle, "currentIndex", thisClass.currentIndex);
          gsap.to(this.target, {
            rotation: targetAngle,
            ease: "power2.out",
            duration: 0.4,
          });
        }

        thisClass.updateIndex(false);
      },
    });
  }

  init() {
    this.setupCarousel();

    this.rotateCircle();

    this.setupFilters();

    this.updateIndex();
  }
}
